//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/SelectBodyList.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[0,"Approximation",1,0],[1,"CurveCollector",0,"Section",0],[0,"DistanceTolerance",1,0],[0,"JoinOutputCurves",1,0],[0,"MaximumGap",1,0],[0,"ModifyInputSheet",1,0],[1,"ProjectToFaces",0,"ScCollector",0],[1,"SheetBodies",0,"SelectBodyList",0],[0,"Type",1,0]],[],[]];
SPLM.Die.CompensateRoughDataBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.CompensateRoughDataBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.CompensateRoughDataBuilder.Types = Object.freeze({
    "SheetBody" : "SheetBody", "Curve" : "Curve"});

SPLM.Die.CompensateRoughDataBuilder.ApproximationType = Object.freeze({
    "Coarse" : "Coarse", "Rough" : "Rough", "Fine" : "Fine", "Exact" : "Exact"});

export default SPLM;